import { EObjectType, Genplan, TFilters } from '@cian/countryside-genplan-component';
import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  trackFiltersChange,
  trackFullscreenOpen,
  trackGeplanShow,
  trackObjectClick,
  trackPhoneShow,
  trackPreviewClick,
} from './tracking';
import { GenplanLayout } from '../../components/GenplanLayout';
import { selectGenplan } from '../../selectors/genplan';
import { selectVillageId } from '../../selectors/village';
import { fetchGenplanOffer } from '../../services/fetchGenplanOffer';
import { useApplicationContext } from '../../utils/applicationContext';

export const GenplanContainer = () => {
  const context = useApplicationContext();
  const genplan = useSelector(selectGenplan);
  const villageId = useSelector(selectVillageId);
  const [isFullscreen, setIsFullscreen] = React.useState(false);

  const handlePolygonClick = React.useCallback(
    (objectType?: EObjectType | null) => {
      if (objectType) {
        trackObjectClick(villageId, objectType);
      }
    },
    [villageId],
  );

  const handleTooltipClick = React.useCallback(
    (id: number) => {
      trackPreviewClick(villageId, id);
    },
    [villageId],
  );

  const handleFiltersChange = React.useCallback(
    (filters: TFilters) => {
      trackFiltersChange(villageId, filters);
    },
    [villageId],
  );

  const toggleFullscreen = React.useCallback(() => {
    const newValue = !isFullscreen;

    setIsFullscreen(newValue);

    if (newValue) {
      trackFullscreenOpen();
    }
  }, [isFullscreen]);

  const offerFetcher = useEventCallback(async (offerId: number) => {
    return fetchGenplanOffer(context, { offerId });
  });

  if (!genplan) {
    return null;
  }

  return (
    <GenplanLayout imageDump={genplan.image}>
      <Genplan
        data={genplan}
        offerFetcher={offerFetcher}
        onPolygonClick={handlePolygonClick}
        onView={trackGeplanShow}
        onTooltipClick={handleTooltipClick}
        onTooltipPhoneShow={trackPhoneShow}
        isFullscreen={isFullscreen}
        toggleFullscreen={toggleFullscreen}
        onFilterChange={handleFiltersChange}
      />
    </GenplanLayout>
  );
};
